module.exports = __webpack_public_path__ + "img/art_sorachi.da45267e.png";